// allowedFileTypes.ts

// Define a readonly array of allowed MIME types
// allowedFileTypes.ts
export const ALLOWED_FILE_TYPES: string[] = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/heif",
  "image/heic",
  "application/pdf",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "text/csv",
];

// Create a comma-separated string version for components like FileButton that expect a string
export const ALLOWED_FILE_TYPES_STRING: string = ALLOWED_FILE_TYPES.join(",");
